import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminSettings from './pages/AdminSettings';
import TenantLogin from './pages/TenantLogin';
import TenantSignup from './pages/TenantSignup';
import TenantDashboard from './pages/TenantDashboard';
import TenantSettings from './pages/TenantSettings';
import WhatsAppTest from './pages/WhatsAppTest';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/settings" element={<AdminSettings />} />
        <Route path="/login" element={<TenantLogin />} />
        <Route path="/signup" element={<TenantSignup />} />
        <Route path="/dashboard" element={<TenantDashboard />} />
        <Route path="/settings" element={<TenantSettings />} />
        <Route path="/test" element={<WhatsAppTest />} />
      </Routes>
    </Router>
  );
}

export default App;
